export const OBTER_GRUPO_USUARIO = 'GRUPO_USUARIO/OBTER_GRUPO_USUARIO'

export const OBTER_GRUPO_USUARIO_ATRIBUTO = 'GRUPO_USUARIO/OBTER_GRUPO_USUARIO_ATRIBUTO'

export const SALVAR_GRUPO_USUARIO = 'GRUPO_USUARIO/SALVAR_GRUPO_USUARIO'

export const INATIVAR_GRUPO_USUARIO = 'GRUPO_USUARIO/INATIVAR_GRUPO_USUARIO'
